import { skipToken, useQuery } from '@tanstack/react-query';

import { type SearchPromosByToggleQuery, searchPromosByToggle } from '~/services/PromoService';

export const promoByToggleQueryKeys = {
  all: ['promo-by-toggle'] as const,
  search: (query: SearchPromosByToggleQuery) => [...promoByToggleQueryKeys.all, query] as const,
};

export function useSearchPromosByToggle(query: SearchPromosByToggleQuery | null) {
  return useQuery({
    queryKey: query ? promoByToggleQueryKeys.search(query) : promoByToggleQueryKeys.all,
    queryFn: query ? ({ signal }) => searchPromosByToggle(query, { signal }) : skipToken,
    enabled: query !== null,
  });
}
